<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BetTypeSwitcher',
  props: {
    eventId: {
      type: [String, Number],
      required: true,
      default: null,
    },
    fetchBestOdds: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapGetters({
      betType: 'RacingOddsComparisonTable/getBetType',
    }),
  },
  methods: {
    betTypeUpdate: function(betType) {
      const { eventId, $store: store } = this;
      if (!eventId) return;
      // Updated the bet-type value in store
      store.dispatch('RacingOddsComparisonTable/updateBetType', betType);
      // get events data
      store.dispatch('RacingOddsComparisonTable/fetchEventDataById', { eventId, betType });
    },
  },
};
</script>

<template>
  <div class="bettype-wrap">
    <div class="bettype-wrap__header">bet type</div>
    <ul class="bettype-wrap__body">
      <li>
        <button
          :class="{'bettype-button--active': betType === 'FixedWin' }"
          class="bettype-button"
          @click="betTypeUpdate('FixedWin')"
        >win</button>
      </li>
      <li>
        <button
          :class="{'bettype-button--active': betType === 'FixedPlace' }"
          class="bettype-button"
          @click="betTypeUpdate('FixedPlace')"
        >place</button>
      </li>
    </ul>
  </div>
</template>
